import React, {useRef} from 'react';
import styled from 'styled-components';
import ImageCarousel from '../../Components/ImageCarousel';
import Arrow from '../../Components/Arrow';

function BannerCarousel(props) {
  const {banners} = props;
  const carouselRef = useRef(null);

  return (
    <Wrapper>
      {banners.length > 0 && (
        <ImageCarousel
          carouselRef={carouselRef}
          showThumbs={false}
          showIndicators={true}
          showArrows={true}
          autoPlay={true}
          interval={5000}
          images={banners}
          renderArrowPrev={() => (
            <Arrow
              onClick={() => {
                carouselRef.current.onClickPrev();
              }}
              type="prev"
            />
          )}
          renderArrowNext={() => (
            <Arrow
              onClick={() => {
                carouselRef.current.onClickNext();
              }}
              type="next"
            />
          )}
          ratio={850 / 1920}
        />
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  aspect-ratio: calc(1920 / 850);
  position: relative;
  background-color: #aace2d;
`;

export default BannerCarousel;
